import useLocalStorage from '../useLocalStorage'

export type IProductTracking = {
  item_list_name?: string
  item_list_type?: string
  item_category?: string
  index?: number
}
interface IProductTrackingStorageFormat {
  // key is product ID
  [key: string]: IProductTracking
}

const defaultProductTrackingStore = {}

const { stored, set } = useLocalStorage<IProductTrackingStorageFormat>(
  'productTracking',
  defaultProductTrackingStore,
)
const useProductTrackingLocalStorage = () => {
  const getStoredProductTrackingItem = (itemId: string): IProductTracking | undefined =>

    stored.value?.[itemId]

  const storeProductTracking = (value: IProductTrackingStorageFormat) => {
    set({
      ...stored.value,
      ...value,
    })
  }

  const deleteProductTrackingItems = (itemIds: string[]) => {
    const storedCopy = Object.fromEntries(
      Object.entries(stored.value).filter(([key]) => !itemIds.includes(key)),
    )

    set(storedCopy)
  }

  return {
    getStoredProductTrackingItem,
    storeProductTracking,
    deleteProductTrackingItems,
  }
}

export default useProductTrackingLocalStorage
